// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Item, ReportsNavState, ReportsNavData } from '../types.tsx';

const addItem =
	(item: Item): Action<ReportsNavState> =>
	({ setState, getState }) => {
		const { data: originalState } = getState();
		const customReports = [...originalState.customReports, item];
		setState({
			data: {
				...originalState,
				customReports,
			},
		});
	};

const deleteItem =
	(id: string): Action<ReportsNavState> =>
	({ setState, getState }) => {
		const { data: originalState } = getState();
		setState({
			data: {
				...originalState,
				customReports: originalState.customReports.filter(
					(existingItem) => String(existingItem.id) !== id,
				),
			},
		});
	};

const editItem =
	(item: Item): Action<ReportsNavState> =>
	({ setState, getState }) => {
		const { data: originalState } = getState();
		setState({
			data: {
				...originalState,
				customReports: originalState.customReports.map((existingItem) =>
					existingItem.id !== item.id ? existingItem : item,
				),
			},
		});
	};

const setItems =
	({ customReports }: ReportsNavData): Action<ReportsNavState> =>
	({ setState }) =>
		setState({ data: { customReports } });

const actions = {
	addItem,
	deleteItem,
	editItem,
	setItems,
} as const;

export default actions;
